import React from 'react';
import PropTypes from 'prop-types';
import Card from './Card';

/**
 * @description DesktopCard
 *
 * @returns {<DesktopCard />}
 */
const DesktopCard = props => {
  const { hidden, lowered } = props;

  return (
    <div
      className={`card card--desktop ${hidden ? 'card--hidden' : ''} ${
        lowered ? 'card--lowered' : ''
      }`}
    >
      <Card {...props} />
    </div>
  );
};

DesktopCard.propTypes = {
  hidden: PropTypes.bool.isRequired,
  lowered: PropTypes.bool.isRequired,
};

export default DesktopCard;
